import BaseComponent from 'scripts/BaseComponent.js';
import GlobalAutocompleteSearchInstance from '../autocomplete-search';

export default class AutocompleteSearchEmptyState extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
    };

    this.dom = {
      $component: component,
    };

    this.state = {
      isEmptyClass: 'is-empty',
    };

    this.mount();
  }

  mount() {
    super.mount();

    GlobalAutocompleteSearchInstance.search.on('render', this.setEmptyStats.bind(this));
  }

  setEmptyStats() {
    const { dom, state } = this;
    const { renderState } = GlobalAutocompleteSearchInstance.search;
    const { query } = renderState.shopify_products.searchBox;

    if (!query) {
      dom.$component.classList.remove(state.isEmptyClass);
      return;
    }

    const allEmpty = Object.keys(renderState)
      .map((key) => renderState[key].hits.results.nbHits)
      .every((hits) => hits === 0);

    if (allEmpty) {
      dom.$component.classList.add(state.isEmptyClass);
    } else {
      dom.$component.classList.remove(state.isEmptyClass);
    }
  }
}
